import React, { useEffect } from 'react';
import { InputDropdown, IOption } from '../../../../../panda';

import { SmallerMarginMixin } from '../InputFieldSelection/styled';

interface IProps {
  name: string;
  options: IOption[];
  setFn: (value: any) => void;
  title?: string;
  emptyOptionTitle?: string;
  smallBottomMargin?: boolean;
  includeEmptyOption?: boolean;
  value: string | number;
}

const BaseInputDropdown: React.FC<IProps> = ({
  name,
  options,
  setFn,
  emptyOptionTitle,
  smallBottomMargin = false,
  includeEmptyOption = true,
  title,
  value,
}) => {
  useEffect(() => {
    if (!options.find((el) => el.value === value)) {
      setFn(options[0].value);
    }
  }, [value, options, setFn]);

  return (
    <InputDropdown
      css={smallBottomMargin ? SmallerMarginMixin : ''}
      includeEmptyOption={includeEmptyOption}
      input={{
        value,
        name,
        onBlur: () => {},
        onChange: (e: any) => setFn(e.target.value),
        onFocus: () => {},
      }}
      isSmall
      isReverse
      title={title}
      meta={{}}
      emptyOptionTitle={emptyOptionTitle}
      options={options}
    />
  );
};

export default BaseInputDropdown;
